<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <v-layout column align-space-around>
        <v-layout justify="center">
            <v-avatar>
              <v-img v-bind:src="loggedInUser.avatar"></v-img>
            </v-avatar>
        </v-layout>
        <v-flex>
          <h1>Profile</h1>
          <h2>{{this.$store.state.user.name}}</h2>
          <!-- <h2>Level: {{this.$store.state.user.level}}</h2> -->
          <h2>{{this.$store.getters.currentLesson.title}}</h2>
          <h2>Email: {{this.$store.state.user.email}}</h2>
          <h2>ID: {{this.$store.state.user.id}}</h2>
          <h3>User Since: {{this.$store.getters.joinDate}}</h3>
        </v-flex>
        <v-btn >Change Avatar</v-btn>
        <v-btn @click="resetAccount()" color="error">Reset Account</v-btn>
        <h3>Switch Lesson:</h3>
        <v-select
          :items="LessonNumbers"
          label="Pick Lesson"
          solo
          v-model="lessonNumber"
        ></v-select>
      <v-card-actions>
        <v-btn large block round outline color="primary" @click="changeLesson()">Submit Changes</v-btn>
      </v-card-actions>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>


<script>
import { db, auth } from '../firebase/index.js'
import { ChangeLesson, ResetQueue } from '../store/actions.js'
export default {
  data: () => ({
      lessonNumber: 0,
      LessonNumbers: [
        { text: 'Level 1 Lesson 1', value: 0 },
        { text: 'Level 1 Lesson 2', value: 1 },
        { text: 'Level 1 Lesson 3', value: 2 },
        { text: 'Level 2 Lesson 1', value: 3 },
        { text: 'Level 2 Lesson 2', value: 4 },
        { text: 'Level 2 Lesson 3', value: 5 },
        { text: 'Level 2 Lesson 4', value: 6 },
        { text: 'Level 3 Lesson 1', value: 7 },
        { text: 'Level 3 Lesson 2', value: 8 },
        { text: 'Level 3 Lesson 3', value: 9 },
        { text: 'Level 3 Lesson 4', value: 10 },
        { text: 'Level 3 Lesson 5', value: 11 },
        { text: 'Level 3 Lesson 6', value: 12 },
        { text: 'Level 3 Lesson 7', value: 13 },
        { text: 'Level 3 Lesson 8', value: 14 },
        { text: 'Level 3 Lesson 9', value: 15 },
      ],
    }),
  name: "Profile",
  created() {
    var user = auth.currentUser;
  },
  computed: {
    loggedInUser() {
      return this.$store.state.user;
    },
  },
  methods: {
    resetAccount() {
      console.log("Reseting User...")
      var user = this.$store.state.user.id
      this.$store.dispatch("resetUser")
    },
    changeLesson() {
      var user = auth.currentUser;
      auth.onAuthStateChanged(user => {
      if (user) {
        console.log("lesson number in profile = " + this.lessonNumber);
        this.$store.dispatch("ChangeLesson", [user, this.lessonNumber]);
        this.$store.dispatch("ResetQueue", user);
      } 
      else {
        this.$router.push("/Login");
      }
      }, function(error){console.log(error)});
    }
  }
};
</script>


<style>
</style>
